module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "label": "被关注自动回复",
      "name": "subscribe"
    }
  }, [_c('el-alert', {
    attrs: {
      "title": "被关注自动回复",
      "type": "warning",
      "description": "当微信用户关注公众号时，自动发送当前配置消息给用户",
      "show-icon": "",
      "closable": false
    }
  }), _vm._v(" "), _c('el-form', {
    ref: "form"
  }, [_c('el-form-item', [_c('MsgSender', {
    ref: "subscribeMsg",
    attrs: {
      "type": _vm.subscribeType
    },
    model: {
      value: (_vm.subscribeData),
      callback: function($$v) {
        _vm.subscribeData = $$v
      },
      expression: "subscribeData"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', [_vm._v("取消")])], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "label": "关键词自动回复",
      "name": "keyword"
    }
  }, [_c('el-alert', {
    attrs: {
      "title": "接收用户消息最先触发：关键词自动回复",
      "type": "warning",
      "description": "根据接收消息的关键词自动发送当前配置消息",
      "show-icon": "",
      "closable": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "reply_add"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addReplyAction
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("添加关键字规则")])], 1), _vm._v(" "), _c('div', {
    staticClass: "reply_list"
  }, _vm._l((_vm.keywordReplyData), function(item, index) {
    return _c('div', {
      staticClass: "reply_item"
    }, [_c('div', {
      staticClass: "keywords_rule_hd clearfix"
    }, [_c('div', {
      staticClass: "info f_l"
    }, [_c('span', [_vm._v("关键字规则: " + _vm._s(item.rule_name))])]), _vm._v(" "), _c('div', {
      staticClass: "opr f_r"
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.itemchange(item, index)
        }
      }
    }, [_c('i', {
      class: {
        'el-icon-caret-top': item.isopen, 'el-icon-caret-bottom': !item.isopen
      }
    })])])]), _vm._v(" "), (item.isopen) ? _c('div', {
      staticClass: "keyword_rule_detail"
    }, [_c('div', {
      staticClass: "keywords"
    }, [(item.is_new) ? _c('div', [_vm._v("\n              规则名："), _c('el-input', {
      staticStyle: {
        "width": "300px"
      },
      attrs: {
        "maxlength": 60
      },
      model: {
        value: (item.rule_name),
        callback: function($$v) {
          _vm.$set(item, "rule_name", $$v)
        },
        expression: "item.rule_name"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "frm-tips"
    }, [_vm._v(_vm._s(item.rule_name.length) + "/60")])], 1) : _c('div', [_vm._v("\n            规则名：" + _vm._s(item.rule_name) + "\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "keywords"
    }, [_c('div', [_c('el-button', {
      on: {
        "click": function($event) {
          return _vm.addNewKeyword(item, index)
        }
      }
    }, [_vm._v("新增关键字")]), _vm._v(" \n              "), _c('span', {
      staticClass: "frm-tips"
    }, [_vm._v("开启则启用完全匹配，关闭则启用包含匹配模式")])], 1), _vm._v(" "), _vm._l((item.keywords_rule), function(rule, i) {
      return _c('div', {
        staticClass: "keywords_rule_item"
      }, [_vm._v("\n              关键字" + _vm._s(i) + "："), _c('el-input', {
        staticStyle: {
          "width": "300px"
        },
        attrs: {
          "maxlength": 30
        },
        model: {
          value: (rule.keyword),
          callback: function($$v) {
            _vm.$set(rule, "keyword", $$v)
          },
          expression: "rule.keyword"
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "frm-tips"
      }, [_vm._v(_vm._s(rule.keyword.length) + "/30")]), _vm._v(" "), _c('el-switch', {
        attrs: {
          "width": 120,
          "active-value": "equal",
          "inactive-value": "contain",
          "inactive-color": "#ccc",
          "active-text": "开启完全匹配",
          "inactive-text": "开启包含匹配",
          "active-color": "#ff5000"
        },
        model: {
          value: (rule.reply_mode),
          callback: function($$v) {
            _vm.$set(rule, "reply_mode", $$v)
          },
          expression: "rule.reply_mode"
        }
      }), _vm._v(" "), _c('el-tooltip', {
        staticClass: "item",
        attrs: {
          "effect": "dark",
          "content": "删除关键字",
          "placement": "top"
        }
      }, [_c('i', {
        staticClass: "el-icon-delete2",
        on: {
          "click": function($event) {
            return _vm.delNewKeyword(item, index, i)
          }
        }
      })])], 1)
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "keywords_tap reply"
    }, [_c('div', {
      staticClass: "keywords_tap_hd"
    }, [_c('span', [_vm._v("回复")])]), _vm._v(" "), _c('div', {
      staticClass: "keywords_tap_bd"
    }, [_c('MsgSender', {
      ref: "keywordsMsg",
      refInFor: true,
      attrs: {
        "type": item.reply_type,
        "id": index
      },
      model: {
        value: (item.reply_content),
        callback: function($$v) {
          _vm.$set(item, "reply_content", $$v)
        },
        expression: "item.reply_content"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "keywords_rule_ft"
    }, [_c('div', {
      staticClass: "opr tr"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.onSubmitKeyword(item, index)
        }
      }
    }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
      on: {
        "click": function($event) {
          return _vm.delAction(item, index)
        }
      }
    }, [_vm._v("删除")])], 1)])])]) : _vm._e(), _vm._v(" "), (!item.isopen) ? _c('div', {
      staticClass: "keywords_rule_bd keywords_rule_overview"
    }, [_c('div', {
      staticClass: "keywords_info keywords clearfix"
    }, [_c('span', {
      staticClass: "keywords_info_title f_l"
    }, [_vm._v("关键词：")]), _vm._v(" "), _c('div', {
      staticClass: "keywords_info_detail"
    }, _vm._l((item.keywords_rule), function(keywordRule) {
      return _c('div', [(keywordRule.keyword) ? _c('span', [_vm._v(_vm._s(keywordRule.keyword))]) : _vm._e()])
    }), 0)])]) : _vm._e()])
  }), 0)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "开启多客服回复",
      "name": "kfreply"
    }
  }, [_c('el-alert', {
    attrs: {
      "title": "接收用户消息未触发关键词自动回复：开启多客服回复",
      "type": "warning",
      "description": "如果未触发关键字,如果开启多客服回复并且有客服在线，则客服回复消息",
      "show-icon": "",
      "closable": false
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.kfreplyload),
      expression: "kfreplyload"
    }]
  }, [_c('el-form', {
    ref: "form"
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否开启多客服回复"
    }
  }, [(_vm.isRequest) ? _c('el-switch', {
    attrs: {
      "active-text": "开启",
      "disabled": "",
      "inactive-text": "关闭",
      "active-color": "#ff5000",
      "inactive-color": "#ccc"
    },
    on: {
      "change": _vm.openKfReplyChange
    },
    model: {
      value: (_vm.isOpenKfReply),
      callback: function($$v) {
        _vm.isOpenKfReply = $$v
      },
      expression: "isOpenKfReply"
    }
  }) : _c('el-switch', {
    attrs: {
      "active-text": "开启",
      "inactive-text": "关闭",
      "active-color": "#ff5000",
      "inactive-color": "#ccc"
    },
    on: {
      "change": _vm.openKfReplyChange
    },
    model: {
      value: (_vm.isOpenKfReply),
      callback: function($$v) {
        _vm.isOpenKfReply = $$v
      },
      expression: "isOpenKfReply"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "label": "消息自动回复",
      "name": "autoreply"
    }
  }, [_c('el-alert', {
    attrs: {
      "title": "接收用户消息并且关键词和多客服都未触发：消息自动回复",
      "type": "warning",
      "description": "如果多客服回复未触发则自动回复当前配置消息",
      "show-icon": "",
      "closable": false
    }
  }), _vm._v(" "), _c('el-form', {
    ref: "form"
  }, [_c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('MsgSender', {
    ref: "autoreplyMsg",
    attrs: {
      "type": _vm.autoreplyType
    },
    model: {
      value: (_vm.autoreplyData),
      callback: function($$v) {
        _vm.autoreplyData = $$v
      },
      expression: "autoreplyData"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', [_vm._v("取消")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3f3d77bc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f3d77bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/brand/wechat/reply.vue
// module id = 2656
// module chunks = 0